import supabase from '../supabase/supabase';
import { images as fallbackImages } from '../data';

export const landingImageFields = [
  {
    key: 'hero',
    settingKey: 'landing_image_hero',
    label: 'Hero image',
    description: 'Main image shown at the top of the landing page.'
  },
  {
    key: 'story',
    settingKey: 'landing_image_story',
    label: 'Our Story image',
    description: 'Editorial image beside The Art of the Drape.'
  },
  {
    key: 'thread',
    settingKey: 'landing_image_thread',
    label: 'Every Thread image',
    description: 'Full-width image in the story banner.'
  },
  {
    key: 'detail',
    settingKey: 'landing_image_detail',
    label: 'Ordering image',
    description: 'Image shown beside the ordering steps.'
  },
  {
    key: 'about',
    settingKey: 'landing_image_about',
    label: 'About ZEVI image',
    description: 'Editorial portrait in the About section.'
  }
];

export async function getLandingImages() {
  const settingKeys = landingImageFields.map((field) => field.settingKey);
  const { data, error } = await supabase
    .from('zevi_site_settings_20260925')
    .select('setting_key,setting_value')
    .in('setting_key', settingKeys)
    .eq('visibility', 'public');

  if (error) {
    throw new Error('Landing-page images could not be loaded.');
  }

  const images = { ...fallbackImages };

  for (const setting of data || []) {
    const field = landingImageFields.find(
      (item) => item.settingKey === setting.setting_key
    );
    const url = setting.setting_value?.url;

    if (field && typeof url === 'string' && url.trim()) {
      images[field.key] = url.trim();
    }
  }

  return images;
}

export async function updateLandingImages(images) {
  const updates = landingImageFields.map((field) => ({
    setting_key: field.settingKey,
    setting_group: 'landing_page',
    setting_value: { url: images[field.key].trim() },
    visibility: 'public',
    updated_at: new Date().toISOString()
  }));

  const { error } = await supabase
    .from('zevi_site_settings_20260925')
    .upsert(updates, { onConflict: 'setting_key' });

  if (error) {
    throw new Error(
      error.message || 'Landing-page image settings could not be saved.'
    );
  }
}